
import { chakra } from "@chakra-ui/react";

export const LoadingContainer = chakra("div", {
  baseStyle: {
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    gap: "12px",
    backgroundColor: "#fff",
  },
});

export const LoadingText = chakra("p", {
  baseStyle: {
    fontSize: "14px",
    color: "#555",
  },
});
